<template>
    <v-app>
        <div class="vue-csv-uploader">
            <v-form>
                <v-row>
                    <v-col
                    cols="12"
                    md="4"
                    >
                        <v-text-field
                        v-model="editdata.name"
                        label="Bestandsvorlage"
                        dense
                        readonly
                        ></v-text-field> 
                    </v-col>
                   <v-col
                    cols="12"
                    md="4"
                    >
                        <v-text-field
                        v-model="editdata.path"
                        label="Pfad der Bestandsvorlage"
                        dense
                        readonly
                        ></v-text-field>
                    </v-col>    
                </v-row>
                <v-row>
                    <v-col
                    cols="12"
                    md="4"
                    >
                        <v-text-field
                        v-model="pstockcomparetemplate.name"
                        :rules="templatenameRules"
                        hint="Vorlagename"
                        label="Name der Bestandsvergleichvorlage"
                        required
                        ></v-text-field> 
                    </v-col> 
                    <v-col
                    cols="12"
                    md="4"
                    >
                        <v-autocomplete
                        v-model="pstockcomparetemplate.path"
                        :items="directories"
                        label="Pfad des Bestandsvergleich"
                        @change="changeDirectory"
                        persistent-hint
                        required
                        >
                            <template v-slot:prepend>
                                <v-tooltip text="Tooltip">
                                    <template v-slot:activator="{ props }">
                                        <v-btn
                                        icon
                                        color="green"
                                        @click="refreshSupplierDirectories"
                                        >
                                        <v-icon v-bind="props">mdi-cached</v-icon>
                                        </v-btn>
                                    </template>
                                </v-tooltip>
                            </template>
                        </v-autocomplete>
                    </v-col>  
                    <v-col
                    cols="12"
                    md="4"
                    >
                        <v-text-field
                        v-model="pstockcomparetemplate.filename"
                        :rules="filenameRules"
                        hint="Dateiname des Bestandsvergleiches"
                        label="Dateiname des Bestandsvergleiches"
                        @change="changeDirectory"
                        required
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                    cols="12"
                    md="4"
                    >   
                    <v-file-input
                        v-model="selectedtemplatefile"
                        show-size
                        label="Vorlagedatei auswählen"
                        @change="onUpload"
                        @click:clear="clearSelectedTemplate"
                        prepend-icon="mdi-cloud-upload"
                    > 
                    </v-file-input>
                    </v-col>
                    <v-col
                        cols="12"
                        md="8"
                        >  
                        <v-text-field
                            v-model="pstockcomparetemplate.description"
                            hint="Beschreibung"
                            label="Beschreibung"
                            ></v-text-field>
                        </v-col>
                </v-row>
                    <v-row>  
                        <v-col
                        cols="12"
                        md="4"
                        >
                        <div class="form-group">
                            <b-form-checkbox
                                id="checkbox-startRow"
                                v-model="pstockcomparetemplate.startRow"
                                name="checkbox-startRow"
                                value="1"
                                unchecked-value="2"
                                >
                                Ohne Header {{pstockcomparetemplate.startRow}}
                            </b-form-checkbox>
                        </div>
                        </v-col>

                    </v-row>
                    <div class="vue-csv-uploader-part-two">
                        <div class="vue-csv-mapping">
                            <table :class="tableClass">
                                <slot name="thead">
                                    <thead>
                                    <tr>
                                        <th width="20">Erforderliche Felder</th>
                                        <th width="50">CSV-Felder Zuordnung</th>
                                        <th width="30">Vergleich mit der Spalte der Bestandsdatei</th>
                                    </tr>
                                    </thead>
                                </slot>
                                <tbody>
                                <tr v-for="(field, key) in fieldsToMap" :key="key" >
                                    <td>{{ field.label }}:</td>
                                    <td>
                                        <select :class="tableSelectClass" :name="`csv_uploader_map_${key}`" v-model="map[field.key]">
                                            <option :value="-1" >Ignorieren</option>
                                            <option v-for="(column, key) in firstRow" :key="key" :value="key">{{ column }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <v-checkbox
                                        v-model="mapcompare[field.compare]"
                                        hide-details
                                        class="shrink mr-2 mt-0"
                                        false-value="0"
                                        true-value="1"
                                        value="0"
                                        ></v-checkbox>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <b-form-group>
                        <b-button href='#' variant='secondary' v-on:click="back">Zurück</b-button>
                        <slot name="submit" :submit="submit" v-if="pstockcomparetemplate.name && pstockcomparetemplate.filename && pstockcomparetemplate.path && sample && form.csv">
                            <input type="submit" :class="buttonClass" @click.prevent="submit" :value="submitBtnText">
                        </slot>
                    </b-form-group>
                </v-form>
        </div>
       </v-app> 
    </template>
    
    <script>
        import { drop, every, forEach, get, isArray, map, set } from 'lodash';
        import axios from 'axios';
        import Papa from 'papaparse';
        export default {
            props: {
                value: Array,
                editdata: null,
                url: {
                    type: String,
                    default: '/admin/platformstockcomparetemplate'
                },
                 /*mapFields: {
                    //required: true
                    type: Array,
                    default: () => {
                        return ['Artikelnummer', 'EAN', 'Bestand','Preis']
                    }
                }, */

                mapFields : {
                    type: Array,
                    default: () => {
                        return [{"key":"articleNumber", "label":"Artikelnummer", "columnnr":"articleNumber_ColumnNr", "compare":"compare_articleNumber"},
                                {"key":"ean", "label":"EAN", "columnnr":"ean_ColumnNr", "compare":"compare_ean"},
                                {"key":"stock", "label":"Bestand", "columnnr":"stock_ColumnNr", "compare":"compare_stock"},
                                {"key":"price", "label":"Preis", "columnnr":"price_ColumnNr", "compare":"compare_price"}]
                    } 
                    
                },
    
        callback: {
                    type: Function,
                    default: () => ({})
                },
                catch: {
                    type: Function,
                    default: () => ({})
                },
                finally: {
                    type: Function,
                    default: () => ({})
                },
                parseConfig: {
                    type: Object,
                    default() {
                        return {};
                    }
                },
                headers: {
                    default: null
                },
                loadBtnText: {
                    type: String,
                    default: "Laden"
                },
                submitBtnText: {
                    type: String,
                    default: "Speichern"
                },
                autoMatchFields: {
                    type: Boolean,
                    default: false
                },
                autoMatchIgnoreCase: {
                    type: Boolean,
                    default: false
                },
                tableClass: {
                    type: String,
                    default: "table"
                },
                checkboxClass: {
                    type: String,
                    default: "form-check-input"
                },
                buttonClass: {
                    type: String,
                    default: "btn btn-primary"
                },
                inputClass: {
                    type: String,
                    default: "form-control-file"
                },
                validation: {
                    type: Boolean,
                    default: true,
                },
                fileMimeTypes: {
                    type: Array,
                    default: () => {
                        return ['text/csv','application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'text/x-csv', 'application/vnd.ms-excel', 'text/plain'];
                    }
                },
                tableSelectClass: {
                    type: String,
                    default: 'form-control'
                },
                canIgnore: {
                   type: Boolean,
                   default: false,
                }
            },
    
            data: () => ({
                form: {
                      csv: null,
                    },
                templatenameRules: [v => !!v || 'Vorlagename ist erforderlich',],
                filenameRules: [
                    v => !!v || 'Dateiname ist erforderlich',
                ],
                pcart04mapFields:[],
                fieldsToMap: [],
                pcart04fieldsToMap: [],
                map: {},
                mapcompare:{},
                hasHeaders: false,
                csv: null,
                sample: null,
                isValidFileMimeType: false,
                fileSelected: false,
                enableSubmit: false,

                country: null,
                directories: [],
                myValue:'',
                selectedtemplatefile:null,
                templatefile: null,
                filedata:null,
                pstockcomparetemplate: {
                    id: 0,
                    platformstocktemplate_id:0,
                    name: null,
                    path: null,
                    filename: null,
                    templateFile: null,
                    templateheader: null,
                    startRow: 2,
                    validitytime: 0,
                    description: '',
                    csvdata: null,
                },
            }),
    
            created() {
                this.pstockcomparetemplate.platformstocktemplate_id = this.editdata.id;
                this.getDirectories('/admin/supplierstocktemplatedirectories/0');
                this.fieldsToMap = this.mapFields;
                if (isArray(this.pcart04mapFields)) {
                    this.pcart04fieldsToMap = map(this.pcart04mapFields, (item) => {
                        return {
                            key: item,
                            label: item
                        };
                    });
                } else {
                    this.pcart04mapFields = map(this.pcart04mapFields, (label, key) => {
                        return {
                            key: key,
                            label: label
                        };
                    });
                }
                this.form.csv = this.buildMappedCsv();
            },
    
            methods: {
                async clearSelectedTemplate(){
                    const _this = this;
                    _this.pstockcomparetemplate.templateFile = null;
                    _this.sample = null;
                    _this.csv = null;
                    _this.pstockcomparetemplate.templateheader=null;
    
                },
                async onUpload() {
                    const _this = this;
                    try {
                        if (_this.selectedtemplatefile) {
                            console.log(_this.selectedtemplatefile.name);
                            _this.clearSelectedTemplate();
                            _this.pstockcomparetemplate.templateFile = _this.selectedtemplatefile.name
                            let reader = new FileReader();
                            reader.readAsText(this.selectedtemplatefile, "UTF-8");
                            reader.onload = function (evt) {
                            _this.sample = get(Papa.parse(evt.target.result, { preview: 1, skipEmptyLines: true }), "data");
                            _this.csv = _this.sample;
                            };
                            reader.onerror = function () {
                            };
                        }
                    } catch (error) {
                        
                    } 
                },
                back: function(){
                    window.location = location.protocol + "//" + location.hostname + "/admin/platformstocktemplates/"+this.pstockcomparetemplate.platformtemplate_id;
                },
                toast(toaster, append = false) {
                    this.$bvToast.toast(`Bitte selektieren Sie die Felder`, {
                    title: `Toaster ${toaster}`,
                    toaster: toaster,
                    solid: true,
                    appendToast: append
                    })
                },
                getArtikelColumns: function(){
                    axios.get('/admin/getallartikelcolumns')
                    .then(function (response) {
                        this.pcart04mapFields = response.data;
                    }.bind(this));
                },
                changeDirectory: function(value) {
                    //this.getTemplateFiles();
                },
                getTemplateFiles: function(){
                    this.supplierfiles = [];
                    this.pstockcomparetemplate.templateFile = '';
                    var dir = this.pstockcomparetemplate.filepath.substring(0, this.pstockcomparetemplate.filepath.indexOf('/'));
                    console.log("DIR: "+dir)
                    axios.get('/admin/platformtemplatefiles/'+dir)
                    .then(function (response) {
                        this.supplierfiles = response.data;
                        if(this.supplierfiles.length == 1)
                            this.pstockcomparetemplate.templateFile = this.supplierfiles[0];
                    }.bind(this)).catch(response => {});
                },

                getPlatformTemplateArtikelTypes: function(){
                    axios.get('/admin/getplatformtemplateartikeltypes')
                        .then(function (response) {
                            this.platformtemplateartikeltypes = response.data;
                        }.bind(this));
                },
                getDirectories: function(url){
                    axios.get(url)
                    .then(function (response) {
                        this.directories = response.data;
                    }.bind(this));
                },
                refreshSupplierDirectories() {
                    this.getDirectories('/admin/supplierstocktemplatedirectories/1');
                },
                submit() {
                    const _this = this;
                    this.form.csv = this.buildMappedCsv();
                    let csvdata = this.form.csv.shift();
                    this.$emit('input', this.form.csv);
                    this.pstockcomparetemplate.csvdata = csvdata;
                    console.log('CSVDATA: '+csvdata);
                    axios.post(this.url,
                        this.pstockcomparetemplate,
                    ).then(response => {
                       // _this.callback(response);
                       console.log(response);
                       this.showMsgBoxOne(response);
                    }).catch(response => {
                        _this.catch(response);
                    }).finally(response => {
                        _this.finally(response);
                    });
                },
                showMsgBoxOne(callback, change) {
                    this.$bvModal.msgBoxOk(callback.data)
                    .then(value => {
                        if(change)
                        {
                            window.location = location.protocol + "//" + location.hostname + "/admin/supplierstocktemplate";
                        }
                    })
                    .catch(err => {
                        // An error occurred
                    })
                },
    
                 buildMappedCsv() {
                    const _this = this;
                    console.log('buildMappedCsv aufgerufen CSV: '+_this.csv);
                    console.log("Mapcompare: "+JSON.stringify(_this.mapcompare));
                    //console.log("Compare: "+get(_this.mapcompare, 'compare_price'));
                    console.log("Map: "+JSON.stringify(_this.map));
                    let csv = this.hasHeaders ? drop(this.csv) : this.csv;
                    console.log('CSV: '+csv);
                    let newRow = {};
                    let i = 0;
                    return map(_this.map, (column, field) => {
                        console.log('i: '+i);
                        console.log('Column: '+column);
                        console.log('Field: '+field);
                        console.log('Compare: '+get(_this.mapcompare, get(this.fieldsToMap, i).compare));
                        console.log("Get: "+JSON.stringify(get(csv, column)));
                        if(column < 0){
                            set(newRow, field, 'Ignorieren');
                        }
                        else {
                            // get(csv, column);
                            set(newRow, field, get(_this.pstockcomparetemplate.templateheader, column));
                        }
                        
                        set(newRow, get(this.fieldsToMap, i).columnnr, column);
                        let comp = get(_this.mapcompare, get(this.fieldsToMap, i).compare) == 1 ? 1 : 0;
                        set(newRow, get(this.fieldsToMap, i).compare, comp);

                        i++;
                        return newRow;
                    });
                    
                    /*
                    return map(csv, (row) => {
                        let newRow = {};
                        let i = 0;
                        forEach(_this.map, (column, field) => {
                            console.log('Column: '+column)
                            console.log('Field: '+field);
                            console.log('Row: '+row); 
                            set(newRow, field, get(row, column)+'#'+column);
                            console.log('NewRow: '+field+ ' => '+get(row, column));
                            console.log('TEST: '+JSON.stringify(get(this.fieldsToMap, i).columnnr));
                            i++;
                            // return newRow;
                        });
                        return newRow;
                    });
                    */
                },
                validFileMimeType() {
                   let file  = this.$refs.csv.files[0];
                    //const mimeType = file.type === "" ? mimeTypes.lookup(file.name) : file.type;
    
                    if (file) {
                        this.fileSelected = true;
                        //this.isValidFileMimeType = this.validation ? this.validateMimeType(mimeType) : true;
                        this.isValidFileMimeType = true;
                    } else {
                        this.isValidFileMimeType = !this.validation;
                        this.fileSelected = false;
                    }
                },
                /*
                validateMimeType(type) {
                    return this.fileMimeTypes.indexOf(type) > -1;
                },
                */
                load() {
                    const _this = this;
                   // this.enableSubmit = false;
                    this.readFile((output) => {
                        _this.sample = get(Papa.parse(output, { preview: 2, skipEmptyLines: true }), "data");
                        _this.csv = get(Papa.parse(output, { skipEmptyLines: true }), "data");
                    });
                },
    
                readFile(callback){
                   // var tempfilename = this.selectedtemplatefile.substring(this.selectedtemplatefile.lastIndexOf('/')+1);
                    console.log('tempfile: ' + this.pstockcomparetemplate.templateFile);
                    axios.get('/admin/gettemplate/'+this.pstockcomparetemplate.templateFile)
                        .then(function (response) {
                            console.log(response.data);
                            callback(response.data);
                            this.toast('b-toaster-top-center');
                        }.bind(this));
                },
                toggleHasHeaders() {
                    this.hasHeaders = !this.hasHeaders;
                },
                makeId(id) {
                    return `${id}${this._uid}`;
                },
                checkprice(price){
                    var regex = /^\d+(\.\d+)*$/;
                    var ret = regex.test(price);
                    console.log(ret)
                    var count = (price.match(/./g)).length;
                    console.log(count)
                    return /^\d+(\.\d+)*$/.test(price);
                }
            },
            watch: {
    
            },
            computed: {
                 firstRow() {
                    this.pstockcomparetemplate.templateheader = get(this, "sample.0");
                    return this.pstockcomparetemplate.templateheader;
                },
    
                pcart04Row() {
                    return get(this, "sample.0");
                },
                showErrorMessage() {
                    return this.fileSelected && !this.isValidFileMimeType;
                },
    
                disabledNextButton() {
                    return this.pstockcomparetemplate.templateFile == null;
                },
            },
        };
    </script>
    